
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/[language]/suggest",
      function () {
        return require("private-next-pages/[market]/[language]/suggest.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/[language]/suggest"])
      });
    }
  